import _ from 'lodash';
import React, { Fragment, ComponentType } from 'react';
import { Helmet } from 'react-helmet';
import AppConfig from '../../AppConfig';
import {
	getPageName,
	getSubSection,
	getSubSectionChild,
} from '../common/window.util';

const withScripting = <P extends {}>(Component: ComponentType<P>) => {
	const WrappedComponent = ({ ...props }: P) => {
		const appName = 'adviser-online';
		const currentSite = 'mlcsecure';
		const currentApp = 'mlcsecure:en:adviser';
		const pageName = getPageName(currentApp);
		const siteSection = 'adviser';
		const pageNameArray = pageName.split(':');
		const siteSubSection = getSubSection(pageName);
		const siteSubSectionChild = getSubSectionChild(pageName);
		const digitalData = {
			page: {
				pageInfo: {
					pageName: pageName,
					site: currentSite,
					language: 'en',
					siteSection: siteSection,
					siteSubSection: siteSubSection,
					siteSubSectionChild: siteSubSectionChild,
					siteType: 'responsive',
					server: window.location.hostname,
					referringUrl: document.referrer,
					hash: window.location.hash,
					sysEnv: window.navigator.userAgent,
					customValues: {},
				},
			},
			components: {},
			formEvent: [],
			event: [],
		};

		return (
			<Fragment>
				<Helmet>
					<script type="text/javascript">
						{`
                            var singlePageAppName = "${appName}";
                            var pageName = "${pageName}";
                            var pageNameArray = "${pageNameArray}"
                            var siteSubsection = "${siteSubSection}"
                            var siteSubSectionChild = "${siteSubSectionChild}"
    
                            var NABRDF = NABRDF || {};
                            NABRDF.currentSite = "${currentSite}";
                            NABRDF.currentApp = "${currentApp}";
                            NABRDF.publish = true;
                            NABRDF.publishPrefixDepth = 3;
    
                            var digitalData = ${JSON.stringify(
															digitalData,
															null,
															'\t'
														)};
                        `}
					</script>
					<script type="text/javascript" src={AppConfig.dynatraceScript} />
					<script type="text/javascript" src={AppConfig.adobeScript} />
				</Helmet>
				<Component {...props} />
			</Fragment>
		);
	};
	WrappedComponent.displayName = `withScripting(${Component.displayName ||
		Component.name}`;
	return WrappedComponent;
};

export default withScripting;
